export default __webpack_public_path__ + "static/media/hbs-k-cbb-1.76ff2c7c.png";